export default function CallToAction() {

  return (
    <div className="bg-gray-100 dark:bg-gray-700 dark:text-gray-100">
      <div className="container mx-auto space-y-8 px-4 py-16 lg:px-8 lg:py-32 xl:max-w-7xl">
        {/* Heading */}
        <div className="text-center">
          <h2 className="mb-4 text-4xl font-black text-black dark:text-white">
            Are you ready to revolutionalize the way we do curb parking?
          </h2>
          <h3 className="mx-auto text-xl font-medium leading-relaxed text-gray-700 lg:w-2/3 dark:text-gray-300">
            Contact us to learn more about our services.
          </h3>
        </div>
        {/* END Heading */}

        {/* Actions */}
        <div className="flex flex-col space-y-4 sm:flex-row sm:items-center sm:justify-center sm:space-x-3 sm:space-y-0">
          <a
            href="mailto:contact@jc-techs.com"
            className="inline-flex items-center justify-center space-x-2 rounded-lg border border-primary-700 bg-primary-700 px-6 py-3 font-semibold leading-6 text-white hover:border-primary-600 hover:bg-primary-600 hover:text-white focus:ring focus:ring-primary-400 focus:ring-opacity-50 active:border-primary-700 active:bg-primary-700 dark:focus:ring-primary-400 dark:focus:ring-opacity-90"
          >
            <span>contact@jc-techs.com</span>
          </a>
        </div>
        {/* END Actions */}
      </div>
    </div>
  );

}